<template>
  <h4 :class="$abem({ block: 'a-title' })" class="primary">
    <span :class="$abem({ block: 'a-title', element: 'prefix', additional: ['primary--text'] })">{{ prefix }}</span>
    <span :class="$abem({ block: 'a-title', element: 'text' })">{{ text }}</span>
  </h4>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    prefix: {
      type: Number,
      required: true,
    }
  }
}
</script>

<style lang="scss">
.a-title {
  font-weight: 500;
  margin: 20px 0;
  text-align: left;
  color: #fff;
  padding: 10px;
  &__prefix {
    opacity: 0.6;
    background-color: white;
    display: inline-block;
    width: 24px;
    border-radius: 50px;
    text-align: center;
    margin: 0 10px 0 5px;
  }
}
</style>
